export var reduxKey = '@@notificationsQueue';
export var actionKey = '@@NOTIFICATIONS';
//# sourceMappingURL=constants.js.map